import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import PageShell from "../components/PageShell";
import { Leadership } from "../components/Leadership";
import { Contact } from "../components/Contact";

export default function MeetUsPage() {
  const navigate = useNavigate();
  return (
    <PageShell>
      <section className="px-6 md:px-10 lg:px-16 pt-36 pb-6 md:pt-40 overflow-hidden">
        <div className="max-w-7xl mx-auto relative">
          <div className="absolute -top-24 right-0 h-72 w-72 rounded-full bg-gold/5 blur-3xl pointer-events-none" />
          <button onClick={() => navigate("/about")} className="inline-flex items-center gap-2 text-silver/60 hover:text-gold transition-colors text-sm font-body mb-8" data-testid="meet-back">
            <ArrowLeft size={16} className="rtl-flip" /> Back to about
          </button>
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
            <div className="overline text-gold mb-5 flex items-center gap-3">
              <span className="h-px w-8 bg-gold/50" /> The People Behind Arco Orbis2
            </div>
            <h1 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Meet <span className="gold-text">Us</span>
            </h1>
            <p className="mt-6 text-silver/70 font-body font-light text-base md:text-lg max-w-2xl">
              When you work with Arco Orbis2, you work with us — directly. There's no account manager to pass you
              along, no faceless team behind a logo. Just two people who've spent their careers doing this for real.
            </p>
          </motion.div>
        </div>
      </section>

      <Leadership />
      <Contact />
    </PageShell>
  );
}
